import eventEmitter from 'event-emitter';

export const emitter = eventEmitter();

export const DOCUMENT_CLICK = 'DOCUMENT_CLICK';
export const WINDOW_RESIZE = 'WINDOW_RESIZE';
export const WINDOW_SCROLL = 'WINDOW_SCROLL';
